import React from 'react'

const GatsbyJS = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 1024 1024" {...props}>
    <path
      fill="#744c9e"
      d="M512 .462C229.485.462.462 229.485.462 512S229.485 1023.538 512 1023.538 1023.538 794.515 1023.538 512 794.515.462 512 .462z"
    />

    <path
      fill="#fff"
      d="M601.902 903.579L120.421 422.098C161.247 243.536 321.058 110.315 512 110.315c133.473 0 251.711 65.116 324.759 165.284l-55.615 49.076C721.895 239.708 623.448 184.093 512 184.093c-141.891 0-262.723 90.129-308.392 216.257l420.05 420.05c102.006-36.94 180.459-123.048 206.739-229.695H656.283v-78.697h257.41c0 190.934-133.221 350.754-311.783 391.579l-.008-.008zM110.382 517.33L506.67 913.618c-217.608-2.837-393.451-178.68-396.288-396.288z"
    />
  </svg>
)

GatsbyJS.href = 'https://gatsbyjs.org'

export default GatsbyJS
